import LoadingBox from 'components/Common/Loading/LoadingBox'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import * as React from 'react'
import styled from 'styled-components'
import TextButtonLoadingSkeleton from 'LuxKit/Button/TextButtonLoadingSkeleton'
import LabelLoadingBox from 'LuxKit/Label/LabelLoadingBox'
import clsx from 'clsx'

const LoaderContainer = styled.div`
  display: grid;
  gap: ${rem(16)};
  grid-template-rows: ${rem(200)} 1fr;
  width: 75vw;
  min-height: ${rem(400)};
  background-color: ${props => props.theme.palette.neutral.default.eight};

  ${mediaQueryUp.tablet} {
    width: ${rem(320)};
  }

  &.size-medium {
    ${mediaQueryUp.desktop} {
      grid-template-rows: ${rem(280)} 1fr;
      width: ${rem(512)};
    }
  }
`

const DetailsContainer = styled(Group)`
  &.variant-opaque {
    padding: 0 ${rem(16)} ${rem(16)} ${rem(16)};
  }
`

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  variant: 'default' | 'opaque'
  size: 'small' | 'medium'
}

function CarouselCardLoadingSkeleton({ size, variant, className, ...rest }: Props) {
  return (
    <LoaderContainer {...rest} className={clsx(className, `size-${size}`, `variant-${variant}`)}>
      <LoadingBox />
      <DetailsContainer className={`variant-${variant}`} direction="vertical" verticalAlign="space-between" gap={size === 'medium' ? 12 : 16}>
        {size === 'medium' && <VerticalSpacer gap={8}>
          <TextLoadingBox typography="body-medium" width="60%" />
          <TextLoadingBox typography="body-large" width="100%" />
          <LabelLoadingBox width={143} />
        </VerticalSpacer>}
        {size === 'small' && <div>
          <Group direction="vertical" gap={4}>
            <LabelLoadingBox width={143} />
            <TextLoadingBox typography="caption-large" width="100%" />
          </Group>
          <TextLoadingBox typography="heading6" width="100%" />
          <TextLoadingBox typography="caption-small" width={80} />
          <Group direction="vertical" gap={16}>
            <LoadingBox height={24} width={164} />
            <TextLoadingBox typography="caption-large" width={32} />
          </Group>
          <TextLoadingBox typography="heading4" width={95} />
        </div>}
        <Group direction="horizontal" horizontalAlign="space-between" className={`variant-${variant}`}>
          <VerticalSpacer gap={4}>
            <LoadingBox height={18} width={132} />
            <LoadingBox height={18} width={128} />
          </VerticalSpacer>
          <TextButtonLoadingSkeleton width="10ch" />
        </Group>
      </DetailsContainer>
    </LoaderContainer>
  )
}

export default React.memo(CarouselCardLoadingSkeleton)
